import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { atom_tourState } from '@app/shared/state/tour.atom';

const InfoContent: React.FC = () => {
    const { t } = useTranslation();
    const state_TourState = useRecoilValue(atom_tourState);
    return (
        <Box style={{ backgroundColor: 'white', touchAction: 'none' }} role="document">
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: 1,
                position: 'relative',
                touchAction: 'none'
            }}>
            </Box>
            <Box className="flex justify-center">
                <Typography id="info-modal-title" variant="h5" component="h2" className="p-5 pb-2">
                    {t('on_tour.dguide_describe.how_to_use_the_tour')}
                </Typography>
            </Box>
            <Typography className="flex align-center p-1 justify-center" style={{ background: 'white' }}>Powered by
                <a href="https://maslol.io" target="_blank" style={{ marginLeft: 5, color: 'blue' }} rel="noreferrer"> Maslol</a>
            </Typography>
            <ReactPlayer
                width="100%"
                height="70vh"
                url={state_TourState?.exp_video?.split('&token=')?.[0]}
                controls
            />
            <Box className="flex justify-center" margin={'15px'}>
                <Button
                    size="small"
                    style={{ color: '#000' }}
                    onClick={() => {
                        window.open(
                            state_TourState?.config?.whatsappLink ||
                            'https://wa.me/message/FD25J6MAVRP5E1'
                        );
                    }}
                    aria-label={t('accessibility.contact_support') as string}
                >
                    {t('on_tour.dguide_describe.still_have_a_problem')}
                </Button>
            </Box>
        </Box>
    );
};

export default InfoContent;
